import { useContext } from 'react';

import { MatrixEncryptionContext } from './MatrixEncryptionContext';

export function useMatrixEncryptionContext() {
  const context = useContext(MatrixEncryptionContext);
  if (!context) throw new Error('useMatrixEncryptionContext must be used within a MatrixEncryptionProvider');

  return context;
}
